import { Component } from '@angular/core';
import { NotificationService } from "../../services/notification.service";
import { CertificateDetails } from './certificateDetails'
import { DeviceCACertificateManagementService } from "./manage-device-ca-certificates-service";
import { ApiResponse } from '../../models/api-response';
import { Utils } from "../../utils/utils";

@Component({
    selector: "mainsystemdetails",
    template: require("./manage-device-ca-certificates.component.html")
})
export class DeviceCACertificateManagementComponent {

    isSuccessRetriever: boolean = false;
    responseData: any;
    resultMessage: string;
    retrievedCACertificates: Array<CertificateDetails>;
    previewCertificate: CertificateDetails
    fileToUpload: any;

    constructor(private deviceCACertificateManagementService: DeviceCACertificateManagementService,
        private notifier: NotificationService) {
        this.notifier.clear();
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.isSuccessRetriever = false;
    }

    retrieveDeviceCACertificates() {
        this.notifier.displayInfo("Retrieving device CA certificates");
        this.isSuccessRetriever = false;
        this.deviceCACertificateManagementService.retrieveCACertificates().subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData) {
                    this.notifier.clear();
                    this.isSuccessRetriever = true;
                    this.retrievedCACertificates = this.typeCastResponse(this.responseData);
                }
            },
            error => {
                this.isSuccessRetriever = false;
                this.notifier.displayApiResponseError(error);
            });
    }

    certificateFileChange(event) {
        this.notifier.displayInfo("Loading certificate preview. Please wait");
        this.previewCertificate = null;
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            let formData: FormData = new FormData();
            formData.append('uploadFile', file, file.name);
            this.deviceCACertificateManagementService.validateCertificate(formData).subscribe(
                resp => {
                    this.fileToUpload = file;
                    this.notifier.clear();
                    this.responseData = resp;
                    if (this.responseData) {
                        this.notifier.clear();
                        this.isSuccessRetriever = true;
                        this.previewCertificate = this.typeCastResponse(this.responseData)[0];
                    }
                },
                error => {
                    this.isSuccessRetriever = false;
                    this.notifier.displayApiResponseError(error);
                });
        }
        else {
            this.notifier.clear();
            this.previewCertificate = null;
        }
    }

    uploadCertificate(event) {
        this.notifier.displayInfo("Uploading certificate. Please wait");
        if (this.fileToUpload) {            
            let formData: FormData = new FormData();
            formData.append('uploadFile', this.fileToUpload, this.fileToUpload.name);
            this.deviceCACertificateManagementService.uploadCertificate(formData).subscribe(
                resp => {
                    this.notifier.clear();
                    this.responseData = resp;
                    if (this.responseData) {
                        this.notifier.displaySuccess(this.responseData.data);
                        this.isSuccessRetriever = true;
                    }
                },
                error => {
                    this.isSuccessRetriever = false;
                    this.notifier.displayApiResponseError(error);
                });
        }
        else {
            this.notifier.clear();
            this.notifier.displayInfo("Upload file not available");
        }
    }

    typeCastResponse(response: any): Array<CertificateDetails> {
        this.resultMessage = "Retrieved Successfully";
        var retrievedCertificates = (response as ApiResponse).data ? response.data.certificates as Array<CertificateDetails> : [];
        return retrievedCertificates;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/DeviceCACertificateManagement/manage-device-ca-certificates-component.ts
 **/